import axiosInstance from "../../axios/axios";
import { formatDate } from "../../helper/formatDate";



export function getHorseCategories() {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/Lookup/GetHorseCategories`).then(response => {
            if (response.status == 200) {
                if (response.data?.responseCode == "200") {
                    const res = response?.data?.result;
                    const list = response?.data?.result?.map((item) => ({
                        label: item?.nameEn ?? '',
                        text: item?.nameEn ?? '',
                        value: item?.id,
                        ...item
                    }))
                    resolve(list ?? [])
                }
            }
            resolve([]);
        }).catch(error => reject(false))
    })
}

export function geteligiblestallions(ownerId, collectionDate) {
    return new Promise((resolve, reject) => {
        axiosInstance.post(`/requestsemencertificate/geteligiblestallions`, {
            ownerId: ownerId,
            searchDate: collectionDate
        }).then(response => {
            if (response.status == 200) {
                if (response.data?.status?.responseCode == "200") {
                    const list = response?.data?.result?.map((item) => ({
                        label: item?.name ?? '',
                        text: item?.name ?? '',
                        value: item?.id,
                        ...item
                    }))
                    resolve(list ?? [])
                }
            }
            resolve([]);
        }).catch(error => reject(false))
    })
}
export function checkPenalty(serviceId, CoveringId, birthDate) {
    return new Promise((resolve, reject) => {
        axiosInstance.post(`/RegisteringNewArabianHorseFoalServiceRequest/HasRegistrationPenalty`, {
            Id: serviceId,
            CoveringId: CoveringId,
            BirthDate: formatDate(birthDate),
        }).then(response => {
            if (response.status == 200) {
                const res = response?.data?.result ?? false;
                resolve(res)
            }
            resolve(false);
        }).catch(error => reject(false))
    })
}

export function getCountries() {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/lookup/getcountries`).then(response => {
            if (response.status == 200) {
                const res = response.data.map((item) => ({
                    label: item?.text,
                    ...item
                }))
                resolve(res ?? [])
            }
            resolve([]);
        }).catch(error => reject([]))
    })
}
export function getHorseColors() {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/lookup/gethorsecolors`).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    const res = response.data?.result.map((item) => ({
                        label: item?.nameEn,
                        text: item?.nameEn,
                        value: item?.id,
                        ...item
                    }))
                    resolve(res ?? [])
                }
            }
            resolve([]);
        }).catch(error => reject([]))
    })
}